import { QUERY_PARAM_KEYS } from "constants/query";

import { useEffect } from "react";

import { DEFAULT_PAGE_INDEX } from "components/constants";
import { useFormikContext } from "formik";
import useDebounce from "hooks/useDebounce";
import useQuery from "hooks/useQuery";
import useQueryUpdater from "hooks/useQueryUpdater";
import { CloseCircle } from "neetoicons";
import { Label, Checkbox, Button } from "neetoui";
import { Input } from "neetoui/formik";
import { useTranslation } from "react-i18next";

import { TYPE } from "./constants";

const Modal = ({ onClose, isOpen }) => {
  const { t } = useTranslation();
  const {
    values: { movie, series, year },
    errors,
    setFieldValue,
  } = useFormikContext();
  const debouncedYear = useDebounce(year, 500);
  const query = useQuery();
  const searchItem = query.get(QUERY_PARAM_KEYS.SEARCH_ITEM) || "";
  const updateQueryParams = useQueryUpdater();

  useEffect(() => {
    if (!searchItem) return;
    let type = null;
    if (movie !== series) {
      type = movie ? TYPE.movie : TYPE.series;
    }

    const filteredQuery = {
      year: debouncedYear && !errors.year ? debouncedYear : null,
      type: type || null,
      page: type || (debouncedYear && !errors.year) ? DEFAULT_PAGE_INDEX : null,
    };

    updateQueryParams(filteredQuery);
  }, [debouncedYear, movie, series]);

  if (!isOpen) return null;

  return (
    <div className="absolute right-4 top-14 z-50 w-72 rounded-md border border-gray-200 bg-white shadow-lg">
      <div className="space-y-4 p-4">
        <div className="space-y-2">
          <div className="flex items-center justify-between">
            <Label>{t("labels.year")}</Label>
            <Button
              className="cursor-pointer rounded-full bg-transparent p-0"
              icon={() => <CloseCircle color="#000" size={20} />}
              size="medium"
              style="text"
              onClick={onClose}
            />
          </div>
          <Input
            maxLength={4}
            name="year"
            placeholder={t("placeHolder.enterYear")}
            rejectCharsRegex={/^[^0-9]*$/g}
          />
        </div>
        <div className="space-y-4">
          <Label>{t("labels.type")}</Label>
          <div className="flex gap-4">
            <Checkbox
              checked={movie}
              label={t("labels.movie")}
              onChange={({ target: { checked } }) =>
                setFieldValue("movie", checked)
              }
            />
            <Checkbox
              checked={series}
              label={t("labels.series")}
              onChange={({ target: { checked } }) =>
                setFieldValue("series", checked)
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
